<script>
    import { getContext } from "svelte";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule";

    /**
 *
 *
 */

    /*                */
    let { variationId } = $props();

    const contentDresonRule = getContext(contentDresonRuleCtxKey);
</script>

<ft9-benefit-tag-v1
    class="reco_cinema__benefit-tag reco_cinema__clickable_element"
    id={`benefit_discount_badge_${variationId}`}
    team="ft6-bcn"
    feature="reco"
    variation-id={variationId}
    data-testid="ft9_benefit_badge_{variationId}"
    remove-expired
    load-on-visibility
    current-context-dreson={contentDresonRule ?? "(und.(ja).(~.(v.1)))"}
>
</ft9-benefit-tag-v1>

<style lang="scss">
    @use "@otto-ec/design-tokens/tokens" as tokens;
    .reco_cinema__benefit-tag {
        top: tokens.$oc-semantic-spacing-25;
        position: relative;
    }
</style>
